/* eslint-disable camelcase */
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@components/design-system';
import { IToken } from '@interface/token';
import { RootState } from '@state/store';
import { Bid } from './bid';
import { Collect } from './collect';
import { Offer } from './offer';
import * as Styles from './styles';

export interface IPurchase {
  token: IToken;
}

export const Purchase: FC<IPurchase> = ({ token }) => {
  const { auction, swap /* , creator_swap */ } = useSelector((state: RootState) => state.token);
  const { contract, token_id } = token;

  const prioritiseRender = () => {
    // if (creator_swap) {
    //   return <Collect {...creator_swap} />;
    // }

    if (swap) {
      return <Collect {...swap} />;
    }

    if (auction) {
      return <Bid {...auction} />;
    }

    return null;
  };

  return (
    <Styles.Container>
      <Box css={{ flexDirection: 'column', '& > *': { marginBottom: '$space$4' } }}>
        {prioritiseRender()}

        <Offer tokenKT={contract.wallet?.address} tokenId={token_id} />
      </Box>
    </Styles.Container>
  );
};
